import _ from "lodash";
import { ELEMENT_KEYS, PROPERTY_KEYS } from "./constants";

const FONT_FAMILIES = [
  {
    label: "Inherit",
    value: "",
  },
  {
    label: "Monospace",
    options: [
      { label: "Courier Prime", value: "font-courier-prime" },
      { label: "Fira Code", value: "font-fira-code" },
      { label: "IBM Plex Mono", value: "font-ibm-plex-mono" },
      { label: "Inconsolata", value: "font-inconsolata" },
      { label: "Monospace", value: "font-monospace" },
      { label: "Space Mono", value: "font-space-mono" },
    ],
  },
  // {
  //   label: "Serif",
  //   options: [
  //     { label: "Arvo", value: "font-arvo" },
  //     { label: "Crimson Text", value: "font-crimson-text" },
  //     { label: "Playfair Display", value: "font-playfair-display" },
  //     { label: "PT Serif", value: "font-pt-serif" },
  //     { label: "Zilla Slab", value: "font-zilla-slab" },
  //   ],
  // },
  {
    label: "Sans Serif",
    options: [
      { label: "Cabin", value: "font-cabin" },
      { label: "Lato", value: "font-lato" },
      { label: "Montserrat", value: "font-montserrat" },
      { label: "Nunito", value: "font-nunito" },
      { label: "Open Sans", value: "font-open-sans" },
      { label: "Poppins", value: "font-poppins" },
      { label: "Raleway", value: "font-raleway" },
      { label: "Roboto", value: "font-roboto" },
      { label: "Source Sans Pro", value: "font-source-sans-pro" },
    ],
  },
  {
    label: "Others",
    options: [
      { label: "Barrio", value: "font-barrio" },
      { label: "Barriecito", value: "font-barriecito" },
      { label: "Borel", value: "font-borel" },
      { label: "DynaPuff", value: "font-dynapuff" },
      { label: "Alfa Slab One", value: "font-alfa-slab-one" },
      { label: "Audiowide", value: "font-audiowide" },
      { label: "Quantico", value: "font-quantico" },
      { label: "Tilt Prism", value: "font-tilt-prism" },
      { label: "Rubik 80s Fade", value: "font-rubik-80s-fade" },
    ],
  },
];

const TEXT_DECORATION_COLORS = [
  {
    label: "Default",
    options: [
      {
        label: "Transparent",
        value: "decoration-transparent",
      },
      {
        label: "White",
        value: "decoration-white",
      },
    ],
  },
  {
    label: "Colors",
    options: [
      { label: "Red", value: "decoration-red-500" },
      { label: "Blue", value: "decoration-blue-500" },
      { label: "Green", value: "decoration-green-500" },
      { label: "Yellow", value: "decoration-yellow-500" },
      { label: "Purple", value: "decoration-purple-500" },
      { label: "Pink", value: "decoration-pink-500" },
      { label: "Orange", value: "decoration-orange-500" },
      { label: "Teal", value: "decoration-teal-500" },
      { label: "Cyan", value: "decoration-cyan-500" },
      { label: "Lime", value: "decoration-lime-500" },
      { label: "Stone", value: "decoration-stone-500" },
      { label: "Amber", value: "decoration-amber-500" },
      { label: "Emerald", value: "decoration-emerald-500" },
      { label: "Sky", value: "decoration-sky-500" },
      { label: "Indigo", value: "decoration-indigo-500" },
      { label: "Violet", value: "decoration-violet-500" },
      { label: "Fuchsia", value: "decoration-fuchsia-500" },
      { label: "Rose", value: "decoration-rose-500" },
    ],
  },
  {
    label: "Gray",
    options: [
      { label: "Gray-100", value: "decoration-gray-100" },
      { label: "Gray-200", value: "decoration-gray-200" },
      { label: "Gray-300", value: "decoration-gray-300" },
      { label: "Gray-400", value: "decoration-gray-400" },
      { label: "Gray-500", value: "decoration-gray-500" },
      { label: "Gray-600", value: "decoration-gray-600" },
      { label: "Gray-700", value: "decoration-gray-700" },
      { label: "Gray-800", value: "decoration-gray-800" },
      { label: "Gray-900", value: "decoration-gray-900" },
    ],
  },
];

const TEXT_COLORS = [
  {
    label: "Default",
    options: [
      {
        label: "Transparent",
        value: "text-transparent",
      },
      {
        label: "White",
        value: "text-white",
      },
    ],
  },
  {
    label: "Colors",
    options: [
      {
        label: "Red",
        value: "text-red-500",
      },
      {
        label: "Blue",
        value: "text-blue-500",
      },
      {
        label: "Green",
        value: "text-green-500",
      },
      {
        label: "Yellow",
        value: "text-yellow-500",
      },
      {
        label: "Purple",
        value: "text-purple-500",
      },
      {
        label: "Pink",
        value: "text-pink-500",
      },
      {
        label: "Orange",
        value: "text-orange-500",
      },
      {
        label: "Teal",
        value: "text-teal-500",
      },
      {
        label: "Cyan",
        value: "text-cyan-500",
      },
      {
        label: "Lime",
        value: "text-lime-500",
      },
      {
        label: "Stone",
        value: "text-stone-500",
      },
      {
        label: "Amber",
        value: "text-amber-500",
      },
      {
        label: "Emerald",
        value: "text-emerald-500",
      },
      {
        label: "Sky",
        value: "text-sky-500",
      },
      {
        label: "Indigo",
        value: "text-indigo-500",
      },
      {
        label: "Violet",
        value: "text-violet-500",
      },
      {
        label: "Fuchsia",
        value: "text-fuchsia-500",
      },
      {
        label: "Rose",
        value: "text-rose-500",
      },
    ],
  },
  {
    label: "Gray",
    options: [
      {
        label: "Gray-100",
        value: "text-gray-100",
      },
      {
        label: "Gray-200",
        value: "text-gray-200",
      },
      {
        label: "Gray-300",
        value: "text-gray-300",
      },
      {
        label: "Gray-400",
        value: "text-gray-400",
      },
      {
        label: "Gray-500",
        value: "text-gray-500",
      },
      {
        label: "Gray-600",
        value: "text-gray-600",
      },
      {
        label: "Gray-700",
        value: "text-gray-700",
      },
      {
        label: "Gray-800",
        value: "text-gray-800",
      },
      {
        label: "Gray-900",
        value: "text-gray-900",
      },
    ],
  },
];

const BG_COLORS = [
  {
    label: "Default",
    options: [
      {
        label: "Transparent",
        value: "bg-transparent",
      },
      {
        label: "White",
        value: "bg-white",
      },
    ],
  },
  {
    label: "Colors",
    options: [
      {
        label: "Red",
        value: "bg-red-500",
      },
      {
        label: "Blue",
        value: "bg-blue-500",
      },
      {
        label: "Green",
        value: "bg-green-500",
      },
      {
        label: "Yellow",
        value: "bg-yellow-500",
      },
      {
        label: "Purple",
        value: "bg-purple-500",
      },
      {
        label: "Pink",
        value: "bg-pink-500",
      },
      {
        label: "Orange",
        value: "bg-orange-500",
      },
      {
        label: "Teal",
        value: "bg-teal-500",
      },
      {
        label: "Cyan",
        value: "bg-cyan-500",
      },
      {
        label: "Lime",
        value: "bg-lime-500",
      },
      {
        label: "Stone",
        value: "bg-stone-500",
      },
      {
        label: "Amber",
        value: "bg-amber-500",
      },
      {
        label: "Emerald",
        value: "bg-emerald-500",
      },
      {
        label: "Sky",
        value: "bg-sky-500",
      },
      {
        label: "Indigo",
        value: "bg-indigo-500",
      },
      {
        label: "Violet",
        value: "bg-violet-500",
      },
      {
        label: "Fuchsia",
        value: "bg-fuchsia-500",
      },
      {
        label: "Rose",
        value: "bg-rose-500",
      },
    ],
  },
  {
    label: "Gray",
    options: [
      {
        label: "Gray-100",
        value: "bg-gray-100",
      },
      {
        label: "Gray-200",
        value: "bg-gray-200",
      },
      {
        label: "Gray-300",
        value: "bg-gray-300",
      },
      {
        label: "Gray-400",
        value: "bg-gray-400",
      },
      {
        label: "Gray-500",
        value: "bg-gray-500",
      },
      {
        label: "Gray-600",
        value: "bg-gray-600",
      },
      {
        label: "Gray-700",
        value: "bg-gray-700",
      },
      {
        label: "Gray-800",
        value: "bg-gray-800",
      },
      {
        label: "Gray-900",
        value: "bg-gray-900",
      },
    ],
  },
];

const BORDER_COLOR = [
  {
    label: "Default",
    options: [
      {
        label: "Transparent",
        value: "border-transparent",
      },
      {
        label: "White",
        value: "border-white",
      },
    ],
  },
  {
    label: "Colors",
    options: [
      {
        label: "Red",
        value: "border-red-500",
      },
      {
        label: "Blue",
        value: "border-blue-500",
      },
      {
        label: "Green",
        value: "border-green-500",
      },
      {
        label: "Yellow",
        value: "border-yellow-500",
      },
      {
        label: "Purple",
        value: "border-purple-500",
      },
      {
        label: "Pink",
        value: "border-pink-500",
      },
      {
        label: "Orange",
        value: "border-orange-500",
      },
      {
        label: "Teal",
        value: "border-teal-500",
      },
      {
        label: "Cyan",
        value: "border-cyan-500",
      },
      {
        label: "Lime",
        value: "border-lime-500",
      },
      {
        label: "Stone",
        value: "border-stone-500",
      },
      {
        label: "Amber",
        value: "border-amber-500",
      },
      {
        label: "Emerald",
        value: "border-emerald-500",
      },
      {
        label: "Sky",
        value: "border-sky-500",
      },
      {
        label: "Indigo",
        value: "border-indigo-500",
      },
      {
        label: "Violet",
        value: "border-violet-500",
      },
      {
        label: "Fuchsia",
        value: "border-fuchsia-500",
      },
      {
        label: "Rose",
        value: "border-rose-500",
      },
    ],
  },
  {
    label: "Gray",
    options: [
      {
        label: "Gray-100",
        value: "border-gray-100",
      },
      {
        label: "Gray-200",
        value: "border-gray-200",
      },
      {
        label: "Gray-300",
        value: "border-gray-300",
      },
      {
        label: "Gray-400",
        value: "border-gray-400",
      },
      {
        label: "Gray-500",
        value: "border-gray-500",
      },
      {
        label: "Gray-600",
        value: "border-gray-600",
      },
      {
        label: "Gray-700",
        value: "border-gray-700",
      },
      {
        label: "Gray-800",
        value: "border-gray-800",
      },
      {
        label: "Gray-900",
        value: "border-gray-900",
      },
    ],
  },
];

const PROPERTIES = [
  {
    label: "Font Family",
    key: PROPERTY_KEYS.FONT_FAMILY,
    options: FONT_FAMILIES,
  },
  {
    label: "Font Size",
    key: PROPERTY_KEYS.FONT_SIZE,
    options: [
      {
        label: "Base",
        value: "text-base",
      },
      {
        label: "XS",
        value: "text-xs",
      },
      {
        label: "SM",
        value: "text-sm",
      },
      {
        label: "LG",
        value: "text-lg",
      },
      {
        label: "XL",
        value: "text-xl",
      },
      {
        label: "2XL",
        value: "text-2xl",
      },
      {
        label: "3XL",
        value: "text-3xl",
      },
      {
        label: "4XL",
        value: "text-4xl",
      },
      {
        label: "5XL",
        value: "text-5xl",
      },
      {
        label: "6XL",
        value: "text-6xl",
      },
      {
        label: "7XL",
        value: "text-7xl",
      },
    ],
  },
  {
    label: "Align",
    key: PROPERTY_KEYS.TEXT_ALIGN,
    options: [
      {
        label: "Left",
        value: "text-left",
      },
      {
        label: "Center",
        value: "text-center",
      },
      {
        label: "Right",
        value: "text-right",
      },
      {
        label: "Justify",
        value: "text-justify",
      },
    ],
  },
  {
    label: "Decoration",
    key: PROPERTY_KEYS.TEXT_DECORATION,
    options: [
      {
        label: "None",
        value: "no-underline",
      },
      {
        label: "Underline",
        value: "underline",
      },
      {
        label: "Overline",
        value: "overline",
      },
      {
        label: "Line Through",
        value: "line-through",
      },
    ],
  },
  {
    label: "Decoration Color",
    key: PROPERTY_KEYS.TEXT_DECORATION_COLOR,
    dependsOn: [[PROPERTY_KEYS.TEXT_DECORATION, ["no-underline"]]],
    options: TEXT_DECORATION_COLORS,
  },
  {
    label: "Decoration Thickness",
    key: PROPERTY_KEYS.TEXT_DECORATION_THICKNESS,
    dependsOn: [[PROPERTY_KEYS.TEXT_DECORATION, ["no-underline"]]],
    options: [
      {
        label: "None",
        value: "decoration-0",
      },
      {
        label: "Thin",
        value: "decoration-1",
      },
      {
        label: "Medium",
        value: "decoration-2",
      },
      {
        label: "Thick",
        value: "decoration-4",
      },
    ],
  },
  {
    label: "Transform",
    key: PROPERTY_KEYS.TEXT_TRANSFORM,
    options: [
      {
        label: "None",
        value: "normal-case",
      },
      {
        label: "Uppercase",
        value: "uppercase",
      },
      {
        label: "Lowercase",
        value: "lowercase",
      },
      {
        label: "Capitalize",
        value: "capitalize",
      },
    ],
  },
  {
    label: "Color",
    key: PROPERTY_KEYS.TEXT_COLOR,
    options: TEXT_COLORS,
  },
  {
    label: "Bg Color",
    key: PROPERTY_KEYS.BG_COLOR,
    options: BG_COLORS,
  },
  {
    label: "Font Weight",
    key: PROPERTY_KEYS.FONT_WEIGHT,
    options: [
      {
        label: "Thin",
        value: "font-thin",
      },
      {
        label: "Extra Light",
        value: "font-extralight",
      },
      {
        label: "Light",
        value: "font-light",
      },
      {
        label: "Normal",
        value: "font-normal",
      },
      {
        label: "Medium",
        value: "font-medium",
      },
      {
        label: "Semi Bold",
        value: "font-semibold",
      },
      {
        label: "Bold",
        value: "font-bold",
      },
      {
        label: "Extra Bold",
        value: "font-extrabold",
      },
    ],
  },
  {
    label: "Font Style",
    key: PROPERTY_KEYS.FONT_STYLE,
    options: [
      {
        label: "Normal",
        value: "not-italic",
      },
      {
        label: "Italic",
        value: "italic",
      },
    ],
  },
  {
    label: "Height",
    key: PROPERTY_KEYS.FLEX_BASIS,
    notAllowedElements: [ELEMENT_KEYS.RAW_ROOT_EDITOR],
    options: [
      {
        label: "10%",
        value: "basis-1/10",
      },
      {
        label: "20%",
        value: "basis-1/5",
      },
      {
        label: "25%",
        value: "basis-1/4",
      },
      {
        label: "33.33%",
        value: "basis-1/3",
      },
      {
        label: "50%",
        value: "basis-1/2",
      },
      {
        label: "66.66%",
        value: "basis-2/3",
      },
      {
        label: "75%",
        value: "basis-3/4",
      },
      {
        label: "80%",
        value: "basis-4/5",
      },
      {
        label: "90%",
        value: "basis-9/10",
      },
      {
        label: "100%",
        value: "basis-full",
      },
    ],
  },
  {
    label: "Width",
    key: PROPERTY_KEYS.WIDTH,
    notAllowedElements: [ELEMENT_KEYS.RAW_ROOT_EDITOR],
    options: [
      {
        label: "10%",
        value: "w-1/10",
      },
      {
        label: "20%",
        value: "w-1/5",
      },
      {
        label: "25%",
        value: "w-1/4",
      },
      {
        label: "30%",
        value: "w-[30%]",
      },
      {
        label: "33.33%",
        value: "w-1/3",
      },
      {
        label: "40%",
        value: "w-[40%]",
      },
      {
        label: "50%",
        value: "w-1/2",
      },
      {
        label: "60%",
        value: "w-[60%]",
      },
      {
        label: "66.66%",
        value: "w-2/3",
      },
      {
        label: "70%",
        value: "w-[70%]",
      },
      {
        label: "75%",
        value: "w-3/4",
      },
      {
        label: "80%",
        value: "w-4/5",
      },
      {
        label: "85%",
        value: "w-5/6",
      },
      {
        label: "90%",
        value: "w-[90%]",
      },
      {
        label: "100%",
        value: "w-full",
      },
    ],
  },
  {
    label: "Border",
    key: PROPERTY_KEYS.BORDER,
    options: [
      {
        label: "None",
        value: "border-none",
      },
      {
        label: "Thin",
        value: "border",
      },
      {
        label: "Medium",
        value: "border-2",
      },
      {
        label: "Thick",
        value: "border-4",
      },
      {
        label: "Extra Thick",
        value: "border-8",
      },
    ],
  },
  {
    label: "Color",
    key: PROPERTY_KEYS.BORDER_COLOR,
    options: BORDER_COLOR,
  },
  {
    label: "Radius",
    key: PROPERTY_KEYS.BORDER_RADIUS,
    options: [
      {
        label: "None",
        value: "rounded-none",
      },
      {
        label: "Small",
        value: "rounded-sm",
      },
      {
        label: "Medium",
        value: "rounded-md",
      },
      {
        label: "Large",
        value: "rounded-lg",
      },
      {
        label: "XL",
        value: "rounded-xl",
      },
      {
        label: "2XL",
        value: "rounded-2xl",
      },
      {
        label: "3XL",
        value: "rounded-3xl",
      },
      {
        label: "Full",
        value: "rounded-full",
      },
    ],
  },
  {
    label: "Style",
    key: PROPERTY_KEYS.BORDER_STYLE,
    options: [
      {
        label: "Solid",
        value: "border-solid",
      },
      {
        label: "Dashed",
        value: "border-dashed",
      },
      {
        label: "Dotted",
        value: "border-dotted",
      },
      {
        label: "Double",
        value: "border-double",
      },
    ],
  },
  {
    label: "Padding",
    key: PROPERTY_KEYS.PADDING,
    options: [
      {
        label: "None",
        value: "p-0",
      },
      {
        label: "Small",
        value: "p-2",
      },
      {
        label: "Medium",
        value: "p-4",
      },
      {
        label: "Large",
        value: "p-6",
      },
      {
        label: "Extra Large",
        value: "p-8",
      },
    ],
  },
  {
    label: "Margin",
    key: PROPERTY_KEYS.MARGIN,
    options: [
      {
        label: "None",
        value: "m-0",
      },
      {
        label: "Auto X-Axis",
        value: "mx-auto",
      },
      {
        label: "Auto Y-Axis",
        value: "my-auto",
      },
      {
        label: "Small",
        value: "m-2",
      },
      {
        label: "Medium",
        value: "m-4",
      },
      {
        label: "Large",
        value: "m-6",
      },
      {
        label: "Extra Large",
        value: "m-8",
      },
    ],
  },
  {
    label: "Gap",
    key: PROPERTY_KEYS.GAP,
    options: [
      { label: "None", value: "gap-0" },
      { label: "X-Small", value: "gap-1" },
      { label: "Small", value: "gap-2" },
      { label: "Medium", value: "gap-4" },
      { label: "Large", value: "gap-6" },
      { label: "X-Large", value: "gap-8" },
      { label: "2X-Large", value: "gap-12" },
      { label: "3X-Large", value: "gap-16" },
    ],
  },
  {
    label: "Bg Image",
    key: PROPERTY_KEYS.BG_IMAGE,
    type: "file",
    allowedElements: [ELEMENT_KEYS.RAW_ROOT_EDITOR],
  },
  {
    label: "Size",
    key: PROPERTY_KEYS.BG_SIZE,
    options: [
      { label: "None", value: "bg-auto" },
      { label: "Cover", value: "bg-cover" },
      { label: "Contain", value: "bg-contain" },
    ],
    allowedElements: [ELEMENT_KEYS.RAW_ROOT_EDITOR],
  },
  {
    label: "Repeat",
    key: PROPERTY_KEYS.BG_REPEAT,
    options: [
      { label: "No Repeat", value: "bg-no-repeat" },
      { label: "Repeat", value: "bg-repeat" },
      { label: "Repeat X", value: "bg-repeat-x" },
      { label: "Repeat Y", value: "bg-repeat-y" },
    ],
    allowedElements: [ELEMENT_KEYS.RAW_ROOT_EDITOR],
  },
  {
    label: "Position",
    key: PROPERTY_KEYS.BG_POSITION,
    options: [
      { label: "Top Left", value: "bg-top-left" },
      { label: "Top Center", value: "bg-top-center" },
      { label: "Top Right", value: "bg-top-right" },
      { label: "Center Left", value: "bg-center-left" },
      { label: "Center", value: "bg-center" },
      { label: "Center Right", value: "bg-center-right" },
      { label: "Bottom Left", value: "bg-bottom-left" },
      { label: "Bottom Center", value: "bg-bottom-center" },
      { label: "Bottom Right", value: "bg-bottom-right" },
    ],
    allowedElements: [ELEMENT_KEYS.RAW_ROOT_EDITOR],
  },
  {
    label: "Backdrop Filter",
    key: PROPERTY_KEYS.BACKDROP_FILTER,
    options: [
      { label: "None", value: "backdrop-filter-none" },
      { label: "Blur", value: "backdrop-filter-blur" },
      { label: "Brightness", value: "backdrop-filter-brightness" },
      { label: "Contrast", value: "backdrop-filter-contrast" },
      { label: "Grayscale", value: "backdrop-filter-grayscale" },
      { label: "Hue Rotate", value: "backdrop-filter-hue-rotate" },
      { label: "Invert", value: "backdrop-filter-invert" },
      { label: "Saturate", value: "backdrop-filter-saturate" },
      { label: "Sepia", value: "backdrop-filter-sepia" },
    ],
  },
  {
    label: "Justify Content",
    key: PROPERTY_KEYS.JUSTIFY_CONTENT,
    options: [
      { label: "Start", value: "justify-start" },
      { label: "Center", value: "justify-center" },
      { label: "End", value: "justify-end" },
      { label: "Between", value: "justify-between" },
      { label: "Around", value: "justify-around" },
      { label: "Evenly", value: "justify-evenly" },
    ],
  },
  {
    label: "Align Items",
    key: PROPERTY_KEYS.ALIGN_ITEMS,
    options: [
      { label: "Start", value: "items-start" },
      { label: "Center", value: "items-center" },
      { label: "End", value: "items-end" },
      { label: "Stretch", value: "items-stretch" },
      { label: "Baseline", value: "items-baseline" },
    ],
  },
  {
    label: "Flex Direction",
    key: PROPERTY_KEYS.FLEX_DIRECTION,
    options: [
      { label: "Row", value: "flex-row" },
      { label: "Row Reverse", value: "flex-row-reverse" },
      { label: "Column", value: "flex-col" },
      { label: "Column Reverse", value: "flex-col-reverse" },
    ],
  },
  {
    label: "Box Shadow",
    key: PROPERTY_KEYS.BOX_SHADOW,
    options: [
      { label: "None", value: "shadow-none" },
      { label: "Small", value: "shadow-sm" },
      { label: "Medium", value: "shadow" },
      { label: "Large", value: "shadow-lg" },
      { label: "XL", value: "shadow-xl" },
      { label: "2XL", value: "shadow-2xl" },
    ],
  },
  {
    label: "Text Shadow",
    key: PROPERTY_KEYS.TEXT_SHADOW,
    options: [
      { label: "None", value: "text-shadow-none" },
      { label: "Small", value: "text-shadow-sm" },
      { label: "Medium", value: "text-shadow" },
      { label: "Large", value: "text-shadow-lg" },
    ],
  },
  {
    label: "Opacity",
    key: PROPERTY_KEYS.OPACITY,
    options: [
      { label: "0%", value: "opacity-0" },
      { label: "10%", value: "opacity-10" },
      { label: "20%", value: "opacity-20" },
      { label: "30%", value: "opacity-30" },
      { label: "40%", value: "opacity-40" },
      { label: "50%", value: "opacity-50" },
      { label: "60%", value: "opacity-60" },
      { label: "70%", value: "opacity-70" },
      { label: "80%", value: "opacity-80" },
      { label: "90%", value: "opacity-90" },
      { label: "100%", value: "opacity-100" },
    ],
  },
  {
    label: "Overflow",
    key: PROPERTY_KEYS.OVERFLOW,
    options: [
      { label: "Visible", value: "overflow-visible" },
      { label: "Hidden", value: "overflow-hidden" },
      { label: "Scroll", value: "overflow-scroll" },
      { label: "Auto", value: "overflow-auto" },
    ],
  },
];

const PROPERTIES_MAP = _.keyBy(PROPERTIES, "key");

export default PROPERTIES_MAP;
